import el from "@cypherpotato/el";
import { api } from "../../api";
import { Dashboard, DashboardTitle } from "../../components/dashboard";
import { MutedText, Paragraph } from "../../components/text";
import { Icon } from "../../components/icon";
import { formatCurrency } from "../../ui/format";

function PlansTable(prices) {

    const emDash = "—";
    const tickCheck = () => el("div.tick", Icon("check-line"), { style: { color: "var(--success)" } });
    const tickDash = () => el("div.tick.text", emDash, { style: { color: "var(--fr-300)" } });
    const tickNeutral = () => el("div.tick.text", Icon("checkbox-blank-circle-line"), { style: { color: "var(--warn)" } });

    return el(".plans-table",
        el(".plan-row.header",
            el(".plan-label-text", "Resource"),
            ["Free", "Pro", "Max"].map(plan =>
                el(".plan-label-title",
                    el("strong", plan),
                    el.state.listening([prices], () =>
                        el("div", prices.value?.[plan] == null ? "—" : formatCurrency(prices.value[plan]), MutedText("/month"))
                    )
                )
            )
        ),
        el(".plan-separator",
            "Inference resources"
        ),
        el(".plan-row",
            el(".plan-label-text", "Access to gateway models"),

            // free
            el(".plan-tier-text", tickNeutral(), "Basic models", {
                title: "Access to models up to $10 output per million tokens."
            }),

            // pro
            el(".plan-tier-text", tickCheck(), "Advanced models", {
                title: "Access to models up to $25 output per million tokens."
            }),

            // max
            el(".plan-tier-text", tickCheck(), "All models", {
                title: "Access to all models, including the most advanced."
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Commission"),

            // free
            el(".plan-tier-text", "25%", {
                title: "25% commission on the amount spent on in. Example: if a model costs $10 per million tokens, you would pay $12.5 per million tokens."
            }),

            // pro
            el(".plan-tier-text", "5%", {
            }),

            // max
            el(".plan-tier-text", tickDash(), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "BYOK", MutedText("Bring your own API key")),

            // free
            el(".plan-tier-text", tickNeutral(), "Limited", {
                title: "With rate limits."
            }),

            // pro
            el(".plan-tier-text", tickCheck(), {
            }),

            // max
            el(".plan-tier-text", tickCheck(), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "JSON Healing", MutedText("Fixes unformatted JSON from models")),

            // free
            el(".plan-tier-text", tickCheck(), {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), {
            }),

            // max
            el(".plan-tier-text", tickCheck(), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Stability routing", MutedText("Routes models based on provider availability")),

            // free
            el(".plan-tier-text", tickCheck(), {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), {
            }),

            // max
            el(".plan-tier-text", tickCheck(), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Complexity routing", MutedText("Routes models based on conversation complexity")),

            // free
            el(".plan-tier-text", tickCheck(), {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), {
            }),

            // max
            el(".plan-tier-text", tickCheck(), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Rate limits"),

            // free
            el(".plan-tier-text", tickNeutral(), "Considerable", {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), "High", {
            }),

            // max
            el(".plan-tier-text", tickCheck(), "Higher", {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Maximum context"),

            // free
            el(".plan-tier-text", tickNeutral(), "64K", {
                title: "Allows sending up to 64 thousand input tokens to models."
            }),

            // pro
            el(".plan-tier-text", tickDash(), {
            }),

            // max
            el(".plan-tier-text", tickDash(), {
            }),
        ),
        el(".plan-separator",
            "RAG resources"
        ),
        el(".plan-row",
            el(".plan-label-text", "Collections"),

            // free
            el(".plan-tier-text", tickNeutral(), "Up to 2 collections", {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), "Unlimited", {
            }),

            // max
            el(".plan-tier-text", tickCheck(), "Unlimited", {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Searches"),

            // free
            el(".plan-tier-text", "Low limits", MutedText("10 searches/minute"), {
            }),

            // pro
            el(".plan-tier-text", "High limits", MutedText("500 searches/minute"), {
            }),

            // max
            el(".plan-tier-text", "Higher limits", MutedText("3,000 searches/minute"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Insertions", { title: "Considers insertion, editing and indexing of documents." }),

            // free
            el(".plan-tier-text", "Low limits", MutedText("100 indexings/day"), {
            }),

            // pro
            el(".plan-tier-text", "High limits", MutedText("10,000 indexings/day"), {
            }),

            // max
            el(".plan-tier-text", "Unlimited", {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Compound processing", { title: "Modal file processing for RAG." }),

            // free
            el(".plan-tier-text", tickDash(), {
            }),

            // pro
            el(".plan-tier-text", tickNeutral(), "Up to 3 files per day", {
            }),

            // max
            el(".plan-tier-text", tickNeutral(), "Up to 10 files per day", {
            }),
        ),
        el(".plan-separator",
            "Included daily subscription token quotas"
        ),
        el(".plan-row",
            el(".plan-label-text", "RAG embeddings (search + insertion)"),
            el(".plan-tier-text", "10K"),
            el(".plan-tier-text", "250K"),
            el(".plan-tier-text", "1M"),
        ),
        el(".plan-row",
            el(".plan-label-text", "Reflex"),
            el(".plan-tier-text", "2K"),
            el(".plan-tier-text", "10K"),
            el(".plan-tier-text", "100K"),
        ),
        el(".plan-row",
            el(".plan-label-text", "Semantic Deciders (Julia-1 only)"),
            el(".plan-tier-text", "5K"),
            el(".plan-tier-text", "50K"),
            el(".plan-tier-text", "100K"),
        ),
        el(".plan-separator",
            "Tools"
        ),
        el(".plan-row",
            el(".plan-label-text", "Internet search"),

            // free
            el(".plan-tier-text", "15", MutedText("Per day"), {
            }),

            // pro
            el(".plan-tier-text", "1,000", MutedText("Per day"), {
            }),

            // max
            el(".plan-tier-text", "10,000", MutedText("Per day"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Bash sandbox"),

            // free
            el(".plan-tier-text", tickDash(), "Limited", {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), "Best", {
            }),

            // max
            el(".plan-tier-text", tickCheck(), "Better", {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Twitter/X search"),

            // free
            el(".plan-tier-text", tickDash(), {
            }),

            // pro
            el(".plan-tier-text", "1,000", MutedText("Per day"), {
            }),

            // max
            el(".plan-tier-text", "10,000", MutedText("Per day"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Deep search"),

            // free
            el(".plan-tier-text", tickDash(), {
            }),

            // pro
            el(".plan-tier-text", "100", MutedText("Per day"), {
            }),

            // max
            el(".plan-tier-text", "1,000", MutedText("Per day"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Document and web page generation"),

            // free
            el(".plan-tier-text", "5", MutedText("Per day"), {
            }),

            // pro
            el(".plan-tier-text", "1,000", MutedText("Per day"), {
            }),

            // max
            el(".plan-tier-text", "50,000", MutedText("Per day"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Image generation and editing"),

            // free
            el(".plan-tier-text", "5", MutedText("Per day*"), {
                title: "Access to basic models."
            }),

            // pro
            el(".plan-tier-text", "500", MutedText("Per day"), {
            }),

            // max
            el(".plan-tier-text", "5,000", MutedText("Per day"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Code execution and advanced requests"),

            // free
            el(".plan-tier-text", "30", MutedText("Per day"), {
            }),

            // pro
            el(".plan-tier-text", "5,000", MutedText("Per day"), {
            }),

            // max
            el(".plan-tier-text", "100,000", MutedText("Per day"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Memory"),

            // free
            el(".plan-tier-text", tickCheck(), {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), {
            }),

            // max
            el(".plan-tier-text", tickCheck(), {
            }),
        ),
        el(".plan-separator",
            "Account resources"
        ),
        el(".plan-row",
            el(".plan-label-text", "Included storage"),

            // free
            el(".plan-tier-text", tickDash(), "30 MB", MutedText("Fixed limit"), {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), "2 GB", MutedText("After $0.50/gb/month"), {
            }),

            // max
            el(".plan-tier-text", tickCheck(), "20 GB", MutedText("After $0.20/gb/month"), {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Conversation retention", MutedText("Gateway logs and audit")),

            // free
            el(".plan-tier-text", tickDash(), {
            }),

            // pro
            el(".plan-tier-text", "2 days retention", {
            }),

            // max
            el(".plan-tier-text", "30 days retention", {
            }),
        ),
        el(".plan-row",
            el(".plan-label-text", "Support"),

            // free
            el(".plan-tier-text", tickDash(), "By email", {
            }),

            // pro
            el(".plan-tier-text", tickCheck(), "Priority", {
            }),

            // max
            el(".plan-tier-text", tickCheck(), "Dedicated", {
            }),
        ),
    )
}

export default function (ctx) {
    const prices = el.state.create(null);

    api.getJson("/api/v1/information/plans.json").then(result => {
        prices.value = Object.fromEntries(result.data.map(item => [item.plan, item.monthlyPrice]));
    });

    return Dashboard(
        DashboardTitle("Account level",
            "Transparent and sustainable pricing and limits."
        ),
        el("h1",
            "Go to production with AIVAX",
            {
                style: {
                    fontWeight: 300
                }
            }
        ),
        Paragraph(
            "At AIVAX, you pay for usage across all functions. By upgrading your plan, you save on inference, gain dedicated support and higher limits ",
            "so you can put your application into production as soon as possible."
        ),
        PlansTable(prices),
        Paragraph("Embedding quotas are for embedding tokens, not response tokens. Usage beyond the included quotas is billed normally. Subscriptions are not offered for Custom plans.")
    )
}